import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/"); return; }
    const session_id = match[1];
    api.post("/auth/session", { session_id })
      .then(async (r) => {
        if (r.data.token) localStorage.setItem("oh_token", r.data.token);
        await refresh();
        toast.success("You're in.");
        window.history.replaceState({}, "", "/");
        navigate("/");
      })
      .catch(() => {
        toast.error("Sign-in failed");
        navigate("/");
      });
  }, []);  // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center oh-label">
      Signing you in…
    </div>
  );
}
